module.exports = __webpack_public_path__ + "static/powerbi-odata-auth-anon-4e7a7a9664c1e29b607e7759a4329e88.png";